// Absence Management Enums and Display Names

// TypeScript Enums matching backend
export enum AbsenceCategory {
  Vacation = 1,
  SickDays = 2,
  MedicalLeave = 3,
  Maternity = 5,
  Parental = 6,
  FamilyHoliday = 7,
  EarlyLeave = 8,
  LateOnShift = 9,
}

export enum AbsenceRequestStatus {
  Pending = 1,
  Approved = 2,
  Denied = 3,
  Cancelled = 4,
  Revoked = 5,
}

export enum BalanceChangeType {
  Earned = 1,
  Used = 2,
  AdminAdjustment = 3,
  CarryOver = 4,
  Expired = 5,
}

export enum EarningFrequency {
  Monthly = 1,
  Quarterly = 2,
  Yearly = 3,
}

// Display Name Mappings
export const AbsenceCategoryNames: Record<number, string> = {
  1: "Vacation",
  2: "Sick Day",
  3: "Medical Leave",
  5: "Maternity Leave",
  6: "Parental Leave",
  7: "Family Holiday",
  8: "Early Leave",
  9: "Late On Shift",
};

export const AbsenceRequestStatusNames: Record<number, string> = {
  1: "Pending",
  2: "Approved",
  3: "Denied",
  4: "Cancelled",
  5: "Revoked",
};

export const BalanceChangeTypeNames: Record<number, string> = {
  1: "Earned",
  2: "Used",
  3: "Admin Adjustment",
  4: "Carry Over",
  5: "Expired",
};

// Color codes for UI
export const AbsenceCategoryColors: Record<number, string> = {
  1: "#2196f3", // Vacation - Blue
  2: "#f44336", // Sick Day - Red
  3: "#9c27b0", // Medical Leave - Purple
  5: "#e91e63", // Maternity - Pink
  6: "#4caf50", // Parental - Green
  7: "#009688", // Family Holiday - Teal
  8: "#3f51b5", // Early Leave - Indigo
  9: "#795548", // Late On Shift - Brown
};

export const AbsenceRequestStatusColors: Record<number, string> = {
  1: "#FFC107", // Pending - Yellow
  2: "#4caf50", // Approved - Green
  3: "#f44336", // Denied - Red
  4: "#9e9e9e", // Cancelled - Gray
  5: "#ff5722", // Revoked - Deep Orange
};

// Helper functions
export const getAbsenceCategoryName = (category: number): string => {
  return AbsenceCategoryNames[category] || "Unknown";
};

export const getAbsenceRequestStatusName = (status: number): string => {
  return AbsenceRequestStatusNames[status] || "Unknown";
};

export const getBalanceChangeTypeName = (changeType: number): string => {
  return BalanceChangeTypeNames[changeType] || "Unknown";
};

export const getAbsenceCategoryColor = (category: number): string => {
  return AbsenceCategoryColors[category] || "#757575";
};

export const getAbsenceRequestStatusColor = (status: number): string => {
  return AbsenceRequestStatusColors[status] || "#757575";
};

